export default __webpack_public_path__ + "static/media/server.01434189.png";